import { useMemo } from 'react';
import { State } from 'models';
import { useSelector } from 'react-redux';

import { ReportViewer } from 'components';

const ShareRegister = () => {
  const { coopId, cooperatives } = useSelector((state: State) => ({
    coopId: state.settings.current_cooperative,
    cooperatives: state.home.cooperatives,
  }));

  const cooperative = useMemo(() => {
    return cooperatives.find((coop) => coop.Id === coopId) || null;
  }, [coopId, cooperatives]);

  return <ReportViewer cooperative={cooperative} entity="share-register" />;
};

export default ShareRegister;
